import { render, staticRenderFns } from "./judgeInfoEntry.vue?vue&type=template&id=494835ec&scoped=true"
import script from "./judgeInfoEntry.vue?vue&type=script&lang=js"
export * from "./judgeInfoEntry.vue?vue&type=script&lang=js"
import style0 from "./judgeInfoEntry.vue?vue&type=style&index=0&id=494835ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494835ec",
  null
  
)

export default component.exports